var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConfigurableDashboard',{attrs:{"dashboard-key":"wms","permission-key":"WmsDashboard","default-widgets":['stockValue']}})
}
var staticRenderFns = []

export { render, staticRenderFns }